import { render } from "./MinusSquareIcon.vue?vue&type=template&id=2b308193"
const script = {}
script.render = render

export default script